import { Component, OnInit, Input, Output, EventEmitter, } from '@angular/core';
import { CookieService } from 'ngx-cookie';
import { UtilsService, CompRouterService } from '../../../../helpers/services/index';

@Component({
  selector: 'app-note-card',
  templateUrl: './note-card.component.html',
  styleUrls: ['./note-card.component.scss']
})
export class NoteCardComponent implements OnInit {
  @Input() resource: any;
  @Input() notes: any;
  @Output() edit = new EventEmitter<Object>();


  constructor(public utils: UtilsService) { }

  ngOnInit() {
  }

  onEdit(data) {
    this.edit.emit(data);
  }

}
